import { useEffect, useRef, useState } from 'react';
import { C, t } from '../constants/dashboardConstants';
import Avatar from './Avatar';

/** ⋮ 더보기 — 메시지 삭제 / 차단 */
function ItemMenu({ blocked, onDelete, onToggleBlock }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    // mousedown이어야 메뉴 항목 클릭 전에 닫히지 않는다
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  const item = {
    display: 'block', width: '100%', textAlign: 'left',
    padding: '14px 20px', background: 'none', border: 'none', cursor: 'pointer',
    whiteSpace: 'nowrap', ...t('16px', 500, C.bk),
  };

  return (
    <div ref={ref} style={{ position: 'relative', flexShrink: 0 }}>
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(o => !o); }}
        aria-label="대화 메뉴"
        style={{
          width: 24, height: 24, background: 'none', border: 'none', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0,
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="5" r="1.6" fill={C.sub} />
          <circle cx="12" cy="12" r="1.6" fill={C.sub} />
          <circle cx="12" cy="19" r="1.6" fill={C.sub} />
        </svg>
      </button>

      {open && (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: 'absolute', top: '28px', right: 0, zIndex: 20,
            background: C.white, border: `1px solid ${C.g200}`, borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.12)', overflow: 'hidden', minWidth: '160px',
          }}
        >
          <button style={item} onClick={() => { setOpen(false); onDelete(); }}>메시지 삭제</button>
          <button
            style={{ ...item, borderTop: `1px solid ${C.g200}` }}
            onClick={() => { setOpen(false); onToggleBlock(); }}
          >
            {blocked ? '차단 해제' : '메시지 차단'}
          </button>
        </div>
      )}
    </div>
  );
}

function ConversationItem({ conv, selected, onClick, onDelete, onToggleBlock }) {
  return (
    <div
      onClick={() => onClick(conv)}
      style={{
        display: 'flex', alignItems: 'center', gap: '16px',
        padding: '28px 24px', borderRadius: '20px', cursor: 'pointer',
        background: selected ? C.white : C.bg,
        border: `1px solid ${C.g200}`,
        boxShadow: selected ? C.shadow : 'inset 2px 2px 15px rgba(0,0,0,0.1)',
        opacity: conv.blocked ? 0.6 : 1,
      }}
    >
      <Avatar url={conv.avatarUrl} name={conv.company} size={50} />

      {/* 내용 */}
      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '11px', minWidth: 0 }}>
            <span style={{ ...t('18px', 600, C.bk), overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {conv.company}
            </span>
            <span style={{ ...t('14px', 400, C.sub), overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {conv.blocked ? '차단됨' : conv.project}
            </span>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
            <span style={t('14px', 400, C.sub)}>{conv.time}</span>
            <ItemMenu
              blocked={conv.blocked}
              onDelete={() => onDelete(conv)}
              onToggleBlock={() => onToggleBlock(conv)}
            />
            {conv.unread > 0 && (
              <div style={{
                minWidth: '18px', height: '18px', borderRadius: '9px', padding: '0 5px',
                background: C.point, display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <span style={{ fontSize: '12px', fontWeight: 700, color: C.bk, fontFamily: 'Pretendard, sans-serif' }}>
                  {conv.unread > 99 ? '99+' : conv.unread}
                </span>
              </div>
            )}
          </div>
        </div>

        <span style={{ ...t('16px', 400, C.g500), overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {conv.preview}
        </span>
      </div>
    </div>
  );
}

export default function ConversationList({
  conversations, selectedId, onSelect, onDelete, onToggleBlock, emptyText = '아직 대화가 없습니다.',
}) {
  return (
    <div style={{ width: '413px', flexShrink: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {conversations.length === 0 ? (
        <div style={{
          padding: '40px 24px', borderRadius: '20px', border: `1px solid ${C.g200}`,
          background: C.bg, textAlign: 'center', ...t('16px', 400, C.sub),
        }}>
          {emptyText}
        </div>
      ) : conversations.map(conv => (
        <ConversationItem
          key={conv.id}
          conv={conv}
          selected={conv.id === selectedId}
          onClick={onSelect}
          onDelete={onDelete}
          onToggleBlock={onToggleBlock}
        />
      ))}
    </div>
  );
}
